import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { TabPanel } from '@mui/lab';
import TabContext from '@mui/lab/TabContext';
import { ASPENDENTAL_FONTS } from '../../../constants/constant';

var TAGPickerTabs = function TAGPickerTabs(_ref) {
  var tabData = _ref.tabData;

  var _React$useState = React.useState('0'),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var handleChange = function handleChange(event, newValue) {
    event.preventDefault();
    setValue(newValue);
  };

  return React.createElement(TabContext, {
    value: value
  }, React.createElement(Box, {
    minHeight: "434px"
  }, React.createElement(Box, {
    sx: {
      borderBottom: 1,
      borderColor: 'divider'
    }
  }, React.createElement(Tabs, {
    value: value,
    onChange: handleChange,
    variant: "fullWidth",
    indicatorColor: "secondary",
    TabIndicatorProps: {
      style: {
        background: 'secondary.main',
        color: 'secondary.main'
      }
    }
  }, tabData.map(function (tab, i) {
    return React.createElement(Tab, {
      key: "tab".concat(i),
      label: tab.label,
      value: "".concat(i),
      sx: [ASPENDENTAL_FONTS.captionLargeRegular, {
        color: 'neutrals.secondary',
        '&.MuiTab-textColorPrimary': {
          color: 'secondary.main'
        }
      }]
    });
  }))), tabData.map(function (tab, i) {
    return React.createElement(TabPanel, {
      key: "panel".concat(i),
      value: "".concat(i),
      sx: {
        padding: '0px',
        overflow: 'auto'
      }
    }, tab.content);
  })));
};

export default TAGPickerTabs;